import { IAnswerMap, IQuestion } from "../types";
import { answerMatches } from "./conditions";

/**
 * The i18n keys to show in a question's hint box, in order.
 *
 * Unconditional `hints` come first, then `conditional_hints` for every value the
 * user selected. Keys are deduped, which is the point: painter's photo hints
 * repeat `…hint.referenceImage` under all four surface types, so a user who
 * picks three of them should still see that line once.
 *
 * Shared sentences therefore have to share a key on purpose — dedup is by key,
 * not by translated text.
 */
export const resolveHints = (
  question: IQuestion,
  answers: IAnswerMap
): string[] => {
  const unconditional = question.hints ?? [];

  const conditional = (question.conditional_hints ?? [])
    .filter((hint) => answerMatches(answers[hint.question_key], [hint.value]))
    .flatMap((hint) => hint.hints);

  const all = [...unconditional, ...conditional];

  // Deduped by index rather than through a `Set`: the webpack build compiles
  // down without `downlevelIteration`, where spreading a `Set` yields the Set
  // itself wrapped in an array — silently emptying the hint box while jest,
  // on its own babel targets, stays green.
  return all.filter((key, index) => all.indexOf(key) === index);
};
